import * as React from 'react';
import { cn } from '@lib/cn';
import { Avatar, AvatarProps } from './Avatar';

export interface AvatarLabelProps extends Omit<AvatarProps, 'size'> {
  name: string;
  subtitle?: string;
  size?: 'sm' | 'md' | 'lg';
}

const AvatarLabel = React.forwardRef<HTMLDivElement, AvatarLabelProps>(
  ({ className, name, subtitle, size = 'md', ...avatarProps }, ref) => {
    return (
      <div ref={ref} className={cn('flex items-center gap-[--spacing-7]', className)}>
        <Avatar size={size} {...avatarProps} />
        <div className="flex flex-col gap-[--spacing-2]">
          <span className="text-sm font-medium text-[--text-dark-primary]">{name}</span>
          {subtitle && (
            <span className="text-sm font-normal text-[--text-dark-secondary]">{subtitle}</span>
          )}
        </div>
      </div>
    );
  },
);

AvatarLabel.displayName = 'AvatarLabel';

export { AvatarLabel };
